export default "__VITE_ASSET___QVDrhSi__"